/**
 * Directive: ccValidationSettings
 */
angular.module('acme.common.directive.ccValidationSettings', [])
.directive('ccValidationSettings', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/ccValidationSettings/ccValidationSettings.tpl.html',
      scope: {
        setting: '=',
        id: '@',
        readonly: '<',
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', '$timeout', function($scope, $timeout) {
        var optionEntities = {
          ids: ['Address', 'Zipcode', 'None'],
          entities: {
            Address: { type: 'Address', label: 'Full Address' },
            Zipcode: { type: 'Zipcode', label: 'Zip code only' },
            None: { type: 'None', label: 'Nothing' }, 
          }
        };

        var ctrl = {
          readonly: false,
          model: {},
          optionEntities: optionEntities.entities,
          options: optionEntities.ids.map(function (id) {
            return optionEntities.entities[id];
          }),

          init: function() {
            ctrl.model = $scope.setting;
            ctrl.readonly = $scope.readonly;
          },

          getValidationOptions: function(type) {

            var r = [];

            if (typeof(type) === 'string' && type.length) {
              switch (type.toLowerCase()) {
                case 'address':
                  r = this.options.slice(0);
                  break;
                case 'zipcode':
                  r = this.options.slice(1);
                  break;
                case 'none':
                  /* falls through */
                default:
                  r = this.options.slice(2);
                  break;
              }
            }else{
              r = this.options.slice(0);
            }

            return r;

          },

          isDisplay: function(type) {
            var r = false;

            if (typeof(type) === 'string' &&
                type.length) {
              if (typeof(this.model.display) === 'string' &&
                  this.model.display.length) {
                r = (type === this.model.display.toLowerCase());
              }
            }

            return r;
          },

          checkValidation: function() {
            var self = this;
            // next tick
            $timeout(function() {
              // Always set to highest available requirement
              self.model.validation = self.getValidationOptions(self.model.display)[0].type;
            });
          }

        };

        $scope.ccValidationSettings = ctrl;
        ctrl.init();

      }]

    };

}]);